<template>
  <component
    :is="component"
    :class="computedClassNames"
    :disabled="disabled"
    :type="type"
    :href="href"
    v-bind="$attrs"
  >
    <slot name="prepend" />
    <slot>{{ label }}</slot>
    <slot name="append" />
  </component>
</template>

<script setup lang="ts">
// TOD: This is deprecated and needs to be replaced with @vp/vue-components
import { computed } from 'vue';

export type btnSizeType = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type btnVariantType = 'solid' | 'outline' | 'text';
export type btnThemeType =
  | 'primary'
  | 'secondary'
  | 'secondary-dark'
  | 'base'
  | 'base-light'
  | 'base-dark'
  | 'base-grey';

export interface Props {
  component?: 'button' | 'a' | 'router-link' | 'nuxt-link';
  label?: string;
  type?: 'submit' | 'button';
  theme?: btnThemeType;
  variant?: btnVariantType;
  rounded?: boolean;
  shadow?: boolean;
  maxWidth?: string;
  minWidth?: string;
  width?: string;
  height?: string;
  size?: btnSizeType;
  disabled?: boolean;
  href?: string;
}

const props = withDefaults(defineProps<Props>(), {
  component: 'button',
  label: '',
  type: 'button',
  theme: 'primary',
  variant: 'solid',
  rounded: false,
  shadow: false,
  size: 'md',
  disabled: false,
});

const computedClassNames = computed(() => {
  const btnTheme = props.theme && `vp-btn-${props.theme}`;
  const btnVariant = props.variant && `vp-btn-${props.variant}`;
  const btnSize = props.size && `vp-btn-${props.size}`;
  return [
    'vp-btn',
    btnTheme,
    btnVariant,
    btnSize,
    {
      'vp-btn-disabled': props.disabled,
      'vp-btn-rounded': props.rounded,
      'vp-btn-shadow': props.shadow,
    },
  ];
});
</script>
